import CrowdStrikeLogo from '@/assets/crowdstrike-logo.svg';
import DefenderLogo from '@/assets/defender-logo.svg';
import SecuritySnaresLogo from '@/assets/securitysnares-logo.svg';
import SentinelOneLogo from '@/assets/sentinelone-logo.svg';
import SidecarLogo from '@/assets/sidecar-logo.svg';
import VMPELogo from '@/assets/vmpe-logo.svg';
import type AssetEditAddFormData from '@/features/AssetAddEditDialog/AssetAddEditDialog.types';
import type { AssetDataProviderLogo } from '@/pages/Assets/Assets.types';

const HOST_ISOLATION_EXCLUSION_CRITERIA: Record<string, string> = {
  excluded_host_name: 'hostname',
  excluded_asset_type: 'asset type',
  excluded_asset_subtype: 'asset subtype',
  excluded_asset_tag: 'asset tags'
};

export const formatHostIsolationExclusionReasons = (
  reasons: string[]
): string =>
  reasons
    .map((reason) => HOST_ISOLATION_EXCLUSION_CRITERIA[reason] ?? reason)
    .join(', ');

export enum ASSET_DATA_PROVIDERS {
  CROWDSTRIKE = 'crowdstrike',
  DEFENDER = 'msdefender',
  GOOGLE_WORKSPACE = 'google-workspace',
  MANUAL = 'manual',
  SECURITYSNARES = 'securitysnares',
  SENTINELONE = 'sentinelone',
  SIDECAR = 'sidecar',
  VMPE = 'vmpe'
}

export const ASSET_DATA_PROVIDER_LABELS: Record<string, string> = {
  [ASSET_DATA_PROVIDERS.CROWDSTRIKE]: 'CrowdStrike',
  [ASSET_DATA_PROVIDERS.DEFENDER]: 'Microsoft Defender',
  [ASSET_DATA_PROVIDERS.GOOGLE_WORKSPACE]: 'Google Workspace',
  [ASSET_DATA_PROVIDERS.MANUAL]: 'Manual Entry',
  [ASSET_DATA_PROVIDERS.SECURITYSNARES]: 'SecuritySnares',
  [ASSET_DATA_PROVIDERS.SENTINELONE]: 'SentinelOne',
  [ASSET_DATA_PROVIDERS.SIDECAR]: 'Sidecar',
  [ASSET_DATA_PROVIDERS.VMPE]: 'Vulnerability Management (VMPE)'
};

export const ASSET_DATA_PROVIDERS_LOGOS: Record<string, AssetDataProviderLogo> =
  {
    crowdstrike: {
      image: CrowdStrikeLogo,
      alt: `${ASSET_DATA_PROVIDER_LABELS.crowdstrike} Logo`
    },
    msdefender: {
      image: DefenderLogo,
      alt: `${ASSET_DATA_PROVIDER_LABELS.msdefender} Logo`
    },
    securitysnares: {
      image: SecuritySnaresLogo,
      alt: `${ASSET_DATA_PROVIDER_LABELS.securitysnares} Logo`
    },
    sentinelone: {
      image: SentinelOneLogo,
      alt: `${ASSET_DATA_PROVIDER_LABELS.sentinelone} Logo`
    },
    sidecar: {
      image: SidecarLogo,
      alt: `${ASSET_DATA_PROVIDER_LABELS.sidecar} Logo`
    },
    vmpe: {
      image: VMPELogo,
      alt: `${ASSET_DATA_PROVIDER_LABELS.vmpe} Logo`
    }
  };

export const DEFAULT_ASSET_FIELDS: AssetEditAddFormData = {
  description: '',
  ip_address: '',
  operating_system: '',
  criticality: '',
  compliance_tags: [],
  asset_subtype: '',
  asset_type: '',
  domain: '',
  user_tags: [],
  asset_name: '',
  organization_id: 1
};

export const ASSET_TOOLTIP_TEXT =
  'Field value has been modified. Reset to update automatically by the system';

export const ASSET_RISK_SCORE_PARTS = {
  rtot_raw: 'Total',
  rd_defense: 'Defense',
  rt_threats: 'Threats',
  re_exposure: 'Exposure',
  ri_importance: 'Criticality',
  rv_vulnerability: 'Vulnerability'
};

export const EMPTY_SCORE_PARTS = {
  rd_defense: 0,
  rt_threats: 0,
  re_exposure: 0,
  ri_importance: 0,
  rv_vulnerability: 0,
  rtot_raw: 0
};
